import { useState } from 'react';
import { cn } from '@/shared/helpers/cn';
import { initials } from '@/shared/helpers/format';
import styles from './Avatar.module.scss';

export interface AvatarProps {
  name: string;
  src?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Avatar do paciente ou do profissional.
 *
 * As iniciais nao sao um placeholder decorativo: 3 caminhos diferentes guardam a
 * foto no banco (`foto`, `foto_redimensionada`, `thumb`) e boa parte da base nao
 * tem nenhuma delas. Falhar para as iniciais e o caso normal, nao a excecao.
 */
export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(src) && !failed;

  return (
    <span className={cn(styles.avatar, styles[size], className)}>
      {showImage ? (
        <img className={styles.image} src={src ?? ''} alt="" onError={() => setFailed(true)} />
      ) : (
        <span className={styles.initials} aria-hidden="true">
          {initials(name)}
        </span>
      )}
    </span>
  );
}
